import { CSSProperties } from "react";

const HEADER_COLOR = "#0f7b8a";
const SIDEBAR_ACTIVE_BG = "#e6f7f7";
const STATUS_COMPLETE = "#22c55e";
const STATUS_COMPLETE_BG = "#dcfce7";
const STATUS_OVERDUE = "#ef4444";
const STATUS_OVERDUE_BG = "#fee2e2";

export const pageWrapper: CSSProperties = {
  padding: "48px",
  maxWidth: "80rem",
  margin: "0 auto",
  fontFamily: "'Amazon Ember', 'Helvetica Neue', Arial, sans-serif",
  fontSize: "1rem",
};

export const pageTitle: CSSProperties = {
  fontSize: "2.5rem",
  fontWeight: 700,
  color: "#111827",
  margin: 0,
};

export const pageSubtitle: CSSProperties = {
  fontSize: "1.125rem",
  color: "#6b7280",
  marginTop: "8px",
};

export const tabRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "32px",
  gap: "32px",
  flexWrap: "wrap",
};

export const tabGroup: CSSProperties = {
  display: "flex",
  gap: "8px",
  borderBottom: "2px solid #e5e7eb",
};

const tabBase: CSSProperties = {
  padding: "16px 32px",
  fontSize: "1.125rem",
  fontWeight: 500,
  background: "none",
  cursor: "pointer",
  color: "#6b7280",
  border: "none",
  borderBottomWidth: "3px",
  borderBottomStyle: "solid",
  borderBottomColor: "transparent",
  marginBottom: "-2px",
};

export const tabActive: CSSProperties = {
  ...tabBase,
  borderBottomColor: HEADER_COLOR,
  color: HEADER_COLOR,
};

export const tabInactive: CSSProperties = {
  ...tabBase,
};

export const filterRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
};

export const filterLabel: CSSProperties = {
  fontSize: "1rem",
  color: "#6b7280",
};

export const filterSelect: CSSProperties = {
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  padding: "10px 16px",
  fontSize: "1rem",
  background: "white",
};

export const taskList: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const emptyState: CSSProperties = {
  border: "2px dashed #e5e7eb",
  borderRadius: "12px",
  padding: "80px",
  textAlign: "center",
  color: "#9ca3af",
  fontSize: "1.125rem",
  background: "rgba(249, 250, 251, 0.5)",
};

export const taskCard: CSSProperties = {
  background: "white",
  borderRadius: "12px",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
  border: "1px solid #e5e7eb",
  padding: "24px 40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const taskName: CSSProperties = {
  fontWeight: 600,
  fontSize: "1.125rem",
  color: "#111827",
  display: "flex",
  alignItems: "center",
  gap: "12px",
};

export const assignedBadge: CSSProperties = {
  fontSize: "0.8rem",
  padding: "4px 10px",
  borderRadius: "6px",
  background: "#f3f4f6",
  color: "#6b7280",
  fontWeight: 500,
};

export const interRaterBadge: CSSProperties = {
  fontSize: "0.8rem",
  padding: "4px 10px",
  borderRadius: "6px",
  background: SIDEBAR_ACTIVE_BG,
  color: HEADER_COLOR,
  fontWeight: 500,
};

export const taskMeta: CSSProperties = {
  fontSize: "0.95rem",
  color: "#6b7280",
  marginTop: "4px",
};

export const taskActions: CSSProperties = {
  display: "flex",
  gap: "12px",
};

export const btnPrimary: CSSProperties = {
  background: HEADER_COLOR,
  color: "white",
  padding: "12px 28px",
  borderRadius: "6px",
  fontWeight: 500,
  fontSize: "1rem",
  border: "1px solid #0a5f6b",
  cursor: "pointer",
};

export const btnSecondary: CSSProperties = {
  background: "white",
  color: "#374151",
  padding: "12px 28px",
  borderRadius: "6px",
  fontWeight: 500,
  fontSize: "1rem",
  border: "1px solid #d1d5db",
  cursor: "pointer",
};

export const btnOutline: CSSProperties = {
  background: "transparent",
  color: HEADER_COLOR,
  padding: "12px 28px",
  borderRadius: "6px",
  fontWeight: 500,
  fontSize: "1rem",
  border: `1px solid ${HEADER_COLOR}`,
  cursor: "pointer",
};

export const modalOverlay: CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 50,
  padding: "48px",
};

export const modalContent: CSSProperties = {
  background: "white",
  borderRadius: "12px",
  boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
  maxWidth: "64rem",
  width: "100%",
  maxHeight: "80vh",
  overflowY: "auto",
};

export const modalHeader: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "24px 40px",
  borderBottom: "1px solid #e5e7eb",
  position: "sticky",
  top: 0,
  background: "white",
};

export const modalTitle: CSSProperties = {
  fontWeight: 700,
  fontSize: "1.5rem",
  color: "#111827",
};

export const modalSubtitle: CSSProperties = {
  fontSize: "1rem",
  color: "#6b7280",
};

export const modalBody: CSSProperties = {
  padding: "40px",
};

export const table: CSSProperties = {
  width: "100%",
  fontSize: "1rem",
  borderCollapse: "collapse",
};

export const th: CSSProperties = {
  textAlign: "left",
  fontSize: "0.95rem",
  color: "#9ca3af",
  borderBottom: "2px solid #e5e7eb",
  padding: "12px 24px 12px 0",
};

export const td: CSSProperties = {
  padding: "12px 24px 12px 0",
  borderBottom: "1px solid #f3f4f6",
  color: "#4b5563",
};

export const tdField: CSSProperties = {
  ...td,
  fontWeight: 500,
  color: "#374151",
};

export const agreeBadge: CSSProperties = {
  fontSize: "0.95rem",
  padding: "4px 14px",
  borderRadius: "9999px",
  fontWeight: 500,
  background: STATUS_COMPLETE_BG,
  color: STATUS_COMPLETE,
};

export const disagreeBadge: CSSProperties = {
  fontSize: "0.95rem",
  padding: "4px 14px",
  borderRadius: "9999px",
  fontWeight: 500,
  background: STATUS_OVERDUE_BG,
  color: STATUS_OVERDUE,
};

export const devBanner: CSSProperties = {
  background: "#fef3c7",
  border: "1px solid #fbbf24",
  borderRadius: "8px",
  padding: "16px 32px",
  marginBottom: "32px",
  fontSize: "1rem",
  color: "#92400e",
  display: "flex",
  alignItems: "center",
  gap: "12px",
};
